import { OrganizationType } from "@core-services/data-types"

export const organizationTypeMapping: Record<OrganizationType, string> = {
  [OrganizationType.Customer]: "Customer",
  [OrganizationType.Partner]: "Partner",
  [OrganizationType.SystemOwner]: "System Owner",
}
